import { IconButton, TableRow } from "@mui/material";
import {
  renderCell,
  SimpleTableCell,
} from "../../../../common/components/functional/simpleTable/cellHelpers";
import { StyledTableCell } from "../../../../common/components/functional/simpleTable/styled";
import { GridMoreVertIcon } from "@mui/x-data-grid-pro";
import { useState } from "react";
import { ActionMenu } from "./ActionMenu";

interface Props {
  rowId: string;
  row: SimpleTableCell[];
  onEditRow: (id: string) => void;
  onDeleteRow: (id: string) => void;
  canModify: boolean;
}

export const TableRowItem = ({
  rowId,
  row,
  onEditRow,
  onDeleteRow,
  canModify,
}: Props) => {
  const [actionMenuAnchor, setActionMenuAnchor] = useState<null | HTMLElement>(
    null,
  );

  return (
    <>
      <TableRow>
        {row.map((field, i) => renderCell(field, i))}
        {canModify ? (
          <>
            <StyledTableCell>
              <IconButton onClick={(e) => setActionMenuAnchor(e.currentTarget)}>
                <GridMoreVertIcon />
              </IconButton>
            </StyledTableCell>

            <ActionMenu
              open={!!actionMenuAnchor}
              anchorEl={actionMenuAnchor}
              onClose={() => setActionMenuAnchor(null)}
              rowId={rowId}
              canModify={canModify}
              onEditRow={onEditRow}
              onDeleteRow={onDeleteRow}
            />
          </>
        ) : (
          <StyledTableCell />
        )}
      </TableRow>
    </>
  );
};
